import React from 'react';
import { CheckCircle, Clock, Briefcase } from 'lucide-react';

interface Props {
  completedToday: number;
  pendingJobs: number;
  totalJobs: number;
}

export default function TechnicianHeader({ completedToday, pendingJobs, totalJobs }: Props) {
  return (
    <div className="bg-gradient-to-br from-sky-700 to-sky-900 rounded-2xl p-5 text-white">
      <div className="flex items-start justify-between mb-4">
        <div>
          <h1 className="text-xl font-700">Today&apos;s Job Queue</h1>
          <p className="text-sky-200 text-sm mt-0.5">Thursday, August 13, 2026 · Leenistech Water Purification</p>
        </div>
        <div className="text-right">
          <p className="text-xs text-sky-300">Cutoff Period</p>
          <p className="font-700 text-white">Aug 1–15, 2026</p>
        </div>
      </div>
      <div className="grid grid-cols-3 gap-3">
        <div className="bg-white/15 rounded-xl p-3 text-center">
          <Briefcase size={18} className="mx-auto text-sky-200 mb-1" />
          <p className="text-2xl font-700 tabular-nums">{totalJobs}</p>
          <p className="text-xs text-sky-200">Total Jobs</p>
        </div>
        <div className="bg-white/15 rounded-xl p-3 text-center">
          <Clock size={18} className="mx-auto text-amber-300 mb-1" />
          <p className="text-2xl font-700 tabular-nums">{pendingJobs}</p>
          <p className="text-xs text-sky-200">Remaining</p>
        </div>
        <div className="bg-white/15 rounded-xl p-3 text-center">
          <CheckCircle size={18} className="mx-auto text-green-300 mb-1" />
          <p className="text-2xl font-700 tabular-nums">{completedToday}</p>
          <p className="text-xs text-sky-200">Completed</p>
        </div>
      </div>
    </div>
  );
}